import { render, staticRenderFns } from "./Day_chart.vue?vue&type=template&id=28187a89&"
import script from "./Day_chart.vue?vue&type=script&lang=js&"
export * from "./Day_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports